// Campus photo for /colleges/massachusetts-institute-of-technology: CC BY 4.0, by ajay_suresh, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AMassachusetts_Institute_of_Technology_(MIT)_(54960815718).jpg), checked 2026-09-30 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/massachusetts-institute-of-technology/; credited under the photo.
const photo = {
    "slug": "massachusetts-institute-of-technology",
    "alt": "The domed Maclaurin Buildings at MIT in Cambridge, Massachusetts",
    "src": "/colleges/massachusetts-institute-of-technology/campus-1600.webp",
    "srcSmall": "/colleges/massachusetts-institute-of-technology/campus-800.webp",
    "srcMid": "/colleges/massachusetts-institute-of-technology/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/massachusetts-institute-of-technology/og.jpg",
    "title": "Massachusetts Institute of Technology (MIT) (54960815718)",
    "author": "ajay_suresh",
    "license": "CC BY 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by/4.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AMassachusetts_Institute_of_Technology_(MIT)_(54960815718).jpg",
    "read": "2026-09-30"
};

export default photo;
